import {useIsDemoUser} from 'src/components/hooks/useIsDemoUser';
import {useTasksControllerGetLastModifiedTasksQuery} from 'src/app/services/api.generated';
import {
  canShowFirstDocGuidance,
  shouldAutoOpenFirstDocGuidance,
} from 'src/utils/quickStartVisibility';

/** Shared first-doc discoverability + auto-open from last-modified tasks. */
export const useFirstDocGuidance = () => {
  const isDemo = useIsDemoUser();
  const {data: tasks = [], isLoading, isError} =
    useTasksControllerGetLastModifiedTasksQuery({numberOfTasks: 10}, {skip: isDemo});
  const input = {
    isDemo,
    tasksLoading: isLoading,
    tasksError: isError,
    recentTaskCount: tasks.length,
  };
  return {
    canShow: canShowFirstDocGuidance(input),
    shouldAutoOpen: shouldAutoOpenFirstDocGuidance(input),
    /** @deprecated Use shouldAutoOpen */
    show: shouldAutoOpenFirstDocGuidance(input),
    tasks,
    isDemo,
    isLoading,
    isError,
  };
};
